module.exports = __webpack_public_path__ + "img/石决明.e92b972d.jpg";